module.exports = __webpack_public_path__ + "static/media/bell-slash.80d45d7b.svg";